import { render, staticRenderFns } from "./RightAngleArrow.vue?vue&type=template&id=0766e770&"
import script from "./RightAngleArrow.vue?vue&type=script&lang=js&"
export * from "./RightAngleArrow.vue?vue&type=script&lang=js&"
import style0 from "./RightAngleArrow.vue?vue&type=style&index=0&id=0766e770&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports